export default function () {
  return {
    dominios: {
      data: [],
    },
  };
}
